// Using this file instead of the default user router shrinks the login bundle by ~ 3mb.
const app = require('loginApp');
const route = require('shared/router/routeLogin');

const requestAccessController = require('app/login/requestAccess/requestAccessController');

const appRoutes = {
    'requestAccess': 'requestAccess',
};

const api = {
    'requestAccess': () => {
        requestAccessController.show(app.getView().getRegion('mainRegion'));
    },
};

route(appRoutes, api);